module.exports = __webpack_public_path__ + "static/media/rio-logo@2x.fbfe91de.png";